// extracted by mini-css-extract-plugin
module.exports = {"module":"Widgets_module__UWhwb","widget":"Widgets_widget__YNEx8","mobileWidgetLabel":"Widgets_mobileWidgetLabel__cmStg","loadingContainer":"Widgets_loadingContainer__6ZY4C"};